import React from 'react';
import {StyleSheet, View, Dimensions} from 'react-native';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
import AVText from 'src/components/elements/AVText';
import {CampusLocationType} from 'src/types/CampusLocationTypes';
import {getDescriber} from './descriptors/campusComponents/DescriptorType';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

type ScanAndPayLocationViewProps = {
  location: CampusLocationType;
  isCoffeeMachine: boolean;
  onLocationClick: (
    machine: CampusLocationType,
    autoAdvanced?: boolean,
  ) => Promise<void>;
  isOnlyTile: boolean;
};

const width = Dimensions.get('window').width;

const {getScanAndPayTile, getTileButton} = getDescriber();

const NewScanAndPayLocationView = (props: ScanAndPayLocationViewProps) => {
  return (
    <View
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel={`Location${
        props.location.displayName ?? props.location.name
      }`}
      aria-label={`Location${
        props.location.displayName ?? props.location.name
      }`}
      accessibilityHint={`Double tap to select ${
        props.location.displayName ?? props.location.name
      }`}
      style={[
        styles.container,
        !props.isOnlyTile && {width: styles.container.width / 2},
      ]}
    >
      <View style={styles.textView}>
        <AVText
          accessibilityLabel={`LocationName${
            props.location.displayName ?? props.location.name
          }`}
          accessibilityRole="text"
          aria-label={`${
            props.location.displayName ?? props.location.name
          }, text`}
          numberOfLines={2}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          style={getScanAndPayTile()['newTitleText']}
        >
          {props.location.displayName ?? props.location.name}
        </AVText>
        <AVText
          accessibilityLabel={Localized.Labels.coffee_machine}
          aria-label={Localized.Labels.coffee_machine}
          style={getScanAndPayTile()['coffeeMachineLabel']}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
        >
          {props.isCoffeeMachine
            ? Localized.Labels.coffee_machine
            : Localized.Labels.scan_and_pay}
        </AVText>
        {getTileButton(
          Localized.Buttons.start_scanning,
          () => props.onLocationClick(props.location),
          false,
          props.isOnlyTile ? undefined : 40,
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: width - Styles.Spacing.m3 * 2,
    marginHorizontal: Styles.Spacing.m2,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: Styles.Spacing.m2,
    marginBottom: Styles.Spacing.m1,
    ...getLayoutDescriber().shadowStyles().lightShadow,
  },
  textView: {
    flex: 1,
    justifyContent: 'center',
    paddingVertical: Styles.Spacing.m3,
    marginHorizontal: Styles.Spacing.m2 + Styles.Spacing.m1,
  },
});

export default NewScanAndPayLocationView;
